<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: (items.highlightArea.top + isMsgTop) + 'px'
              }"></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
              }"></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content">{{ items.content }}</div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList flex">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
                  <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="items.btnList.includes('know')" @click="nextTask" class="gj-pointer knowBtn">我知道了</div>
              <template v-if="items.btnList.includes('continue')">
                <div @click="setUserGuideState" class="gj-pointer knowBtn gj-mr4">继续添加</div>
                <div @click="nextTask" class="gj-pointer completeBtn">下一步</div>
              </template>
              <div v-if="items.btnList.includes('complete')" @click="completeTask" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <div v-if="items.lineType == 2" class="user-guide-point-vertical">
            <div class="user-guider-line-vertical"></div>
          </div>
          <div v-else class="user-guide-point" :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {mapGetters} from "vuex";
import {userGuideMixin} from "@/minxins";
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'

export default {
  name: "new-user-guide",
  mixins: [userGuideMixin],
  props: {
    guideRef: {
      value: null
    }
  },
  data() {
    return {
      bootSteps: 0,
      startStep: 'storeAuthorize',
      data: [],
      taskName: '',
      taskList: {
      },
      isMsgTop: 0,
      clientWidth: 0,
      taskItem: {},
      subtractHeight: 0,
      addWidth: 0,
    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate : true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.taskItem = this.userGuideTaskItem
    this.bootSteps = 1;
    this.taskName = this.startStep;
    this.clientWidth = document.body.clientWidth
    const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
    const subtractHeight =  isNavHorizontal ? 0 : 40;
    const addWidth =  isNavHorizontal ? 0 : 60;
    this.subtractHeight = subtractHeight;
    this.addWidth = addWidth;
    this.taskList = {
        storeAuthorize: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: {
              width: 84,
              height: 34,
              top: 147 - subtractHeight,
              left: 30 + addWidth,
            },
            guideArea: {
              top: 130 - subtractHeight,
              left: 168 + addWidth,
            },
            guideWidth: 60,
            content: "点击【添加产品】，开始添加产品资料吧~",
            btnList: [],
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'modal',
            needMask: false,
            modalArea: {
              width: 1100
            },
            guideWidth: 60,
            guideRef: null,
            content: "将您线下的产品维护到系统进行管理，让您多店铺补货更加方便~如果没有维护产品资料，则您无法在系统管理线下自营仓的产品，也不能在系统走供应链流程哦~",
            btnList: ['video'],
          },
          {
            id: 3,
            class: "user-guide-three",
            type: 'default',
            lineType:2,
            highlightArea: {
              width: this.clientWidth - 60 - addWidth,
              height: 100,
              top: 190  - subtractHeight,
              left: 30 + addWidth,
            },
            needMask: true,
            guideArea: {
              top: 400 - subtractHeight,
              left: 965,
            },
            guideWidth: 60,
            content: "您已添加了产品资料，可以留在此页面继续添加，也可去添加其他资料或做产品关联哦~",
            btnList: ['continue'],
          }
        ],
      }
    this.data = this.taskList[this.startStep];

    this.$nextTick(()=> {
      this.$forceUpdate()
    })
  },
  methods: {
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      this.bootSteps++;
      let activeItem = this.data.find(item => item.id === this.bootSteps);
      if(activeItem && activeItem.type === 'menu') {
        this.$store.commit(SET_USER_GUIDE_MENU_PATH, activeItem.path);
      }
      
    },
    openNoviceGuide() {
      this.bootSteps = 2
      this.startStep = ''
      this.data = [];
      this.$gjCreate(NoviceGuide)
    },
    async nextTask() { // 下个任务

      const taskItem = this.taskItem
      const {finishTaskList, nextTask} =  await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode)
      if (this.taskItem.taskStatus != 'COMPLETED' && finishTaskList){
        this.completeTask();
      }else if (nextTask){// 有下一步
        if (this.isWaitTurnOn(nextTask.taskStatus)){// 任务未开启，需要 打开新手指引弹窗
          this.$message.warning( `${nextTask.taskChildName}任务未开启，请先开启任务~`)
          this.openNoviceGuide();
        }else {//下一步不属于当前组件，跳转新页面
          this.jumpToGuidePage(nextTask, () => {
            this.bootSteps = 0;
            this.$emit('finishGuide');
            this.$emit('closeModal');
          })
        }
      }else {
        this.cancel()
      }

      // if(this.taskName === 'storeAuthorize') {

      //   this.bootSteps = 2;
      //   this.data = this.taskList.adAuthorize;
      //   this.taskName = 'adAuthorize';
      //   this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      //   this.$router.push({path: '/sale/listing'})
        
      // } else if(this.taskName === 'adAuthorize') {
      //   // 根据起始步骤判断是否跳过步骤一
      //   if(this.startStep === 'adAuthorize') {
      //     this.bootSteps = 1;
      //     this.data = this.taskList.mailboxAuthorize;
      //     this.taskName = 'mailboxAuthorize';
      //     this.$emit('closeModal')
      //     this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      //   } else {
      //     this.bootSteps = 2;
      //     this.data = this.taskList.mailboxAuthorize;
      //     this.taskName = 'mailboxAuthorize';
      //     this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      //   }
      // }
    },
    completeTask() {
      this.bootSteps = 0;
      this.data = [];
      this.$emit('closeModal');
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskItem?.taskTypeCode
        }
      })
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 302px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point-vertical {
    width: 40px;
    position: absolute;
    left: 50%;
    top: -120px;

    .user-guider-line-vertical {
      width: 2px;
      height: 120px;
      
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        // top: 50%;
        margin-top: -4px;
        left: -3px;
      }
    }
  }
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>